<template>
  <div id="app" class="min-h-screen">
    <VersionRefreshBanner v-if="isUserSurface" />
    <router-view />
    <RedeemSandboxPanel v-if="isDev && isUserSurface" />
    <DialogHost />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import DialogHost from './components/DialogHost.vue'
import RedeemSandboxPanel from './components/RedeemSandboxPanel.vue'
import VersionRefreshBanner from './components/VersionRefreshBanner.vue'
import { isVoidUserPath, setVoidRouteActive } from './theme'

const isDev = import.meta.env.DEV

const route = useRoute()
const isUserSurface = computed(() => isVoidUserPath(route.path))

watch(
  () => route.path,
  (path) => {
    setVoidRouteActive(isVoidUserPath(path))
  },
  { immediate: true },
)
</script>
